import { Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import { RequireAdmin } from './components/RequireAdmin'
import { Layout } from './components/Layout'
import { Dashboard } from './pages/Dashboard'
import { Applications } from './pages/Applications'
import { ApplicationDetail } from './pages/ApplicationDetail'
import { Credentials } from './pages/Credentials'
import { CredentialDetail } from './pages/CredentialDetail'
import { ChangeDayView } from './pages/ChangeDayView'
import { Owners } from './pages/Owners'
import { BusinessUnits } from './pages/BusinessUnits'
import { AuditLog } from './pages/AuditLog'
import { Reports } from './pages/Reports'
import { Settings } from './pages/Settings'

function App() {
  return (
    <ProtectedRoute>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="changes/:date" element={<ChangeDayView />} />
          <Route path="applications" element={<Applications />} />
          <Route path="applications/:id" element={<ApplicationDetail />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="credentials/:id" element={<CredentialDetail />} />
          <Route path="owners" element={<Owners />} />
          <Route path="business-units" element={<BusinessUnits />} />
          <Route path="audit" element={<RequireAdmin><AuditLog /></RequireAdmin>} />
          <Route path="reports" element={<Reports />} />
          <Route path="settings" element={<RequireAdmin><Settings /></RequireAdmin>} />
        </Route>
      </Routes>
    </ProtectedRoute>
  )
}

export default App
